import React from 'react';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="n-home">
      <section className="n-hero" aria-labelledby="n-hero-title">
        <img
          className="n-hero-image"
          src="/images/gym-interior.png"
          alt="パーソナルジムN伏見のトレーニングルーム"
          loading="eager"
        />
        <div className="n-hero-overlay" aria-hidden="true" />
        <div className="n-hero-content">
          <h1 id="n-hero-title">仕事や日常の疲れを<br /><em>リセット</em>する時間に。</h1>
          <p className="n-hero-lead">ただ鍛えるだけではなく、<br />楽しく身体を動かし、<br />心と身体をリフレッシュする。</p>
          <span className="n-hero-divider" aria-hidden="true" />
          <p className="n-hero-statement">「また行きたい」と自然に思える、<br /><strong>大人の男性のためのパーソナルジム。</strong></p>
          <a className="n-hero-cta" href="https://lin.ee/sPhllf4M" target="_blank" rel="noopener noreferrer">
            公式LINEで体験を予約する <span aria-hidden="true">↗</span>
          </a>
          <a className="n-hero-instagram" href="https://www.instagram.com/fushimipersonaln/" target="_blank" rel="noopener noreferrer">
            <svg className="n-hero-instagram-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle className="n-hero-instagram-dot" cx="18" cy="6" r="1" />
            </svg>
            Instagram <span>@fushimipersonaln</span> <span aria-hidden="true">↗</span>
          </a>
        </div>
        <a className="n-scroll-cue" href="#concept"><span>SCROLL</span><i aria-hidden="true" /></a>
      </section>

      <section className="n-concept" id="concept">
        <div className="n-section-heading">
          <span className="n-eyebrow">01 / THE CONCEPT</span>
          <h2>Reset your day.<br /><em>Move with ease.</em></h2>
        </div>
        <div className="n-concept-copy">
          <p className="n-concept-jp">身体を整えることは、<br />日々を整えること。</p>
          <p>忙しい毎日の中で、自分のために身体を動かす。<br />無理なく続けられるトレーニングで、心まで軽くなる時間を。</p>
        </div>
      </section>

      <section className="n-approach" id="approach">
        <div className="n-approach-heading">
          <span className="n-eyebrow">02 / A BETTER ROUTINE</span>
          <h2>Training that<br />fits your life.</h2>
        </div>
        <div className="n-approach-list">
          <article className="n-approach-item">
            <span>01</span>
            <div>
              <h3>PERSONAL</h3>
              <p>その日の体調や目標に合わせて、一人ひとりに向き合います。</p>
            </div>
          </article>
          <article className="n-approach-item">
            <span>02</span>
            <div>
              <h3>REFRESH</h3>
              <p>気持ちよく身体を動かし、心身をリフレッシュする習慣を。</p>
            </div>
          </article>
          <article className="n-approach-item">
            <span>03</span>
            <div>
              <h3>YOUR PACE</h3>
              <p>運動経験や生活リズムに合わせて、無理のない一歩から。</p>
            </div>
          </article>
        </div>
      </section>

      <section className="n-contact" id="contact">
        <span className="n-eyebrow">03 / START HERE</span>
        <h2>Make time for yourself.</h2>
        <p>まずは体験から。新しい習慣を、一緒にはじめませんか。</p>
        <a className="n-contact-cta" href="https://lin.ee/sPhllf4M" target="_blank" rel="noopener noreferrer">
          公式LINEで体験を予約する <span aria-hidden="true">↗</span>
        </a>
      </section>
    </div>
  );
};

export default Home;